import api from "../../../api";
import React from "react";
import utils from "../../../utils";
import values from "../../../values";
import Context from "../../../context";
import CompanyScreen from "..";

import { TModal } from "../../../types/common.type";
import { useQuery } from "react-query";
import { DeleteModal } from "../../../components";
import { IFindUserInformation } from "../../../types/common.interface";
import { ICreateAndUpdateCompany } from "../../../types/company.interface";

const SuperAgentCompanyContainer = () => {
  // ** ====================================================================================================================
  // ** --------------------------------------------------------------------------------------------------------------------
  // **                                               Value Validations
  // ** --------------------------------------------------------------------------------------------------------------------
  const [showModal, setShowModal] = React.useState<TModal>("NONE");
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [selectedCompany, setSelectedCompany] = React.useState<any>();
  const [allCompanyInfo, setAllCompanyInfo] =
    React.useState<IFindUserInformation>({
      limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
      page: 1,
    });
  const [requestCompany, setRequestCompany] =
    React.useState<IFindUserInformation>({
      page: 1,
      limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
      search: { base: "", value: "" },
      filters: {
        province: undefined,
        city: undefined,
        superAgent: undefined,
      },
    });

  // ** --------------------------------------------------------------------------------------------------------------------
  // ** ====================================================================================================================

  // !! ====================================================================================================================
  // !! --------------------------------------------------------------------------------------------------------------------
  // !!                                                Start API Cal
  // !! --------------------------------------------------------------------------------------------------------------------
  // ? Panel-wide academic year (سال تحصیلی). It has to be in the query key as well as the request, otherwise
  // ? react-query serves the previous year's cached rows when the year is switched.
  const { selectedYear } = React.useContext(Context.AcademicYear);

  const resultCompany = useQuery(
    [
      values.useQueryKeys.getAllCompany,
      requestCompany?.page,
      requestCompany?.search?.value,
      requestCompany?.filters,
      selectedYear?._id,
    ],
    () =>
      api.post.superAgent.findCompany({
        filters: requestCompany?.filters,
        search: requestCompany?.search,
        limit: requestCompany?.limit,
        page: requestCompany?.page,
        academicYear: selectedYear?._id,
      })
  );
  const { refetch } = resultCompany;
  // !! --------------------------------------------------------------------------------------------------------------------
  // !! ====================================================================================================================

  // ** ====================================================================================================================
  // ** --------------------------------------------------------------------------------------------------------------------
  // **                                               Local Functions
  // ** --------------------------------------------------------------------------------------------------------------------
  async function createFunction(formData: ICreateAndUpdateCompany) {
    setIsLoading(true);
    const result = await api.post.common.createCompany(formData);
    if (result) {
      utils.successHandler(Number(2010)); // result.CODE === 2021
      resultCompany.refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }
  async function updateFunction(formData: ICreateAndUpdateCompany) {
    setIsLoading(true);
    const result = await api.put.common.updateCompany(formData);
    if (result) {
      utils.successHandler(Number(2010));
      resultCompany.refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }
  async function deleteFunction(userId: string) {
    setIsLoading(true);
    const result = await api.dele.administrator.deleteCompany(userId);
    if (result) {
      utils.successHandler(Number(2010));
      resultCompany.refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }

  async function approveFunction(userId: string) {
    console.log(userId);
    setIsLoading(true);
    const result = await api.post.administrator.approveCompany(userId);
    if (result) {
      utils.successHandler(Number(2010));
      refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }

  async function approveDocumentsFunction(companyId: string) {
    setIsLoading(true);
    const result = await api.put.administrator.ApproveCompanyDocuments(
      companyId
    );
    if (result) {
      utils.successHandler(Number(2010));
      refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }

  // ** --------------------------------------------------------------------------------------------------------------------
  // ** ====================================================================================================================

  // ?? ====================================================================================================================
  // ?? --------------------------------------------------------------------------------------------------------------------
  // ??                                                JSX Container
  // ?? --------------------------------------------------------------------------------------------------------------------
  return (
    <Context.CompanyScreen.Provider
      value={{
        showModal,
        isLoading,
        setIsLoading,
        setShowModal,
        createFunction,
        updateFunction,
        deleteFunction,
        allCompanyInfo,
        selectedCompany,
        setAllCompanyInfo,
        setSelectedCompany,
        requestCompany,
        setRequestCompany,
        approveFunction,
        approveDocumentsFunction,
      }}
    >
      <CompanyScreen rqCompany={resultCompany} role="SUPER_AGENT_SCHOOL" />
      <DeleteModal
        onClose={() => setShowModal("NONE")}
        open={showModal === "DELETE"}
        loading={isLoading}
        onSubmit={deleteFunction}
        user={selectedCompany}
      />
    </Context.CompanyScreen.Provider>
  );

  // ?? --------------------------------------------------------------------------------------------------------------------
  // ?? ====================================================================================================================
};

export default SuperAgentCompanyContainer;
